import { v4 as uuid } from 'uuid';
import UmlClassShape from '../../Types/UmlClassShape';
import UmlCaption from '../../Types/UmlCaption';
import UmlMemberText from '../../Types/UmlMemberText';

const MIN_WIDTH = 180;
const MAX_WIDTH = 420; // long signatures ellipsis + title-tooltip in the UI instead of growing forever
const MIN_HEIGHT = 100;

// Same style of content-aware sizing as UmlClassWidget.getMinSize(), so a
// generated shape doesn't need an immediate manual resize for a normal class.
function computeShapeSize(parsed) {
  const distinctVisibilities = new Set(parsed.members.map(function getVisibility(member) { return member.visibility; })).size;
  const width = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, parsed.name.length * 8 + 40));
  const height = Math.max(MIN_HEIGHT, 56 + parsed.members.length * 22 + distinctVisibilities * 20);
  return { width, height };
}

/**
 * Builds a ready-to-add UmlClassShape instance from a parseCsClass() result.
 * @param {{name: string, stereotype: string|null, members: object[]}} parsed
 * @param {number} x
 * @param {number} y
 * @param {boolean} [collapsed=false] - build the shape already collapsed (see UmlClassShape.collapsed)
 * @returns {UmlClassShape}
 */
export function buildClassShapeFromParsedCs(parsed, x, y, collapsed = false) {
  const caption = new UmlCaption(uuid(), 0, 0, parsed.name, parsed.stereotype);
  const { width, height } = computeShapeSize(parsed);
  const shape = new UmlClassShape(uuid(), x, y, width, height, caption, parsed.description, parsed.inherits, collapsed);
  parsed.members.forEach(function addMember(member) {
    shape.addMember(new UmlMemberText(uuid(), member.text, member.visibility, member.memberKind, member.description, member.paramCount, member.smells, member.name, member.dependencies));
  });
  return shape;
}
